import { use_slice_generation } from '@/hooks/store/use_slices';
import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';
import { useMemo } from 'react';

export function HOOK_FIELD__has_effect_on_generation(field: FIELD__base) {
  const { generation_current } = use_slice_generation(['generation_current']);
  const { graph } = generation_current.tool;

  const out = useMemo(() => get_is_used_in_generation(), [graph, field]);

  function get_is_used_in_generation() {
    let out = graph.node_and_field__has_effect_on_generation_runtime(field);

    return out;
  }

  return out;
}
